import { render, staticRenderFns } from "./gzh-reply.vue?vue&type=template&id=c24990a2&"
import script from "./gzh-reply.vue?vue&type=script&lang=js&"
export * from "./gzh-reply.vue?vue&type=script&lang=js&"
import style0 from "./gzh-reply.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports